import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title = 'ClachSync - eスポーツ大会カレンダー',
  description = 'ClachSync（クラッシュシンク）は、eスポーツ大会の日程を一元管理できる無料カレンダーアプリです。複数の大会情報をまとめて確認し、お気に入りのチームや大会をフィルタリングできます。',
  keywords = 'eスポーツ,esports,大会,トーナメント,カレンダー,スケジュール,ゲーム大会,ClachSync,クラッシュシンク',
  image = '/og-image.png',
  type = 'website'
}) => {
  const location = useLocation();
  const currentUrl = `https://clashsync.jp${location.pathname}`;
  const fullImageUrl = image.startsWith('http') ? image : `https://clashsync.jp${image}`;

  // ページごとのタイトル調整
  const pageTitle = location.pathname === '/' ? title : `${title} | ClachSync`;

  return (
    <Helmet>
      {/* 基本的なメタタグ */}
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph Protocol */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:site_name" content="ClachSync" />
      <meta property="og:locale" content="ja_JP" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />

      {/* 追加のSEO最適化 */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
    </Helmet>
  );
};

export default SEO;
